import { ColorEnum } from '@/constants/color'
import CheckedRadioIcon from '@/features/ui/inputs/components/RadioButton/parts/CheckedRadioIcon'
import UncheckedRadioIcon from '@/features/ui/inputs/components/RadioButton/parts/UncheckedRadioIcon'
import { FC } from 'react'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface RadioControlProps {
    checked: boolean
    error?: boolean
    disabled?: boolean
}

const RadioControl: FC<RadioControlProps> = ({ checked, disabled, error }) => {
    const { styles } = useStyles(stylesheet, { checked, error, disabled })

    if (checked) {
        return <CheckedRadioIcon color={styles.control.color} />
    }

    return (
        <UncheckedRadioIcon
            {...(disabled && { fill: ColorEnum.GRAY_200 })}
            color={styles.control.color}
        />
    )
}

const stylesheet = createStyleSheet({
    control: {
        variants: {
            checked: {
                true: {
                    color: ColorEnum.BRICK_600,
                },
                false: {
                    color: ColorEnum.JET_100,
                },
            },
            error: {
                true: {
                    color: ColorEnum.BRICK_500,
                },
            },
            disabled: {
                true: {
                    color: ColorEnum.GRAY_300,
                },
            },
        },
    },
})

export default RadioControl
